/* eslint-disable */
import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import "./css/Hero.css";
import { Box, Container, Grid, Stack } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useCallback } from "react";
import heroImg from "../img/webp/01-Hero Section/img-hero.webp"
import TextTransition, { presets } from 'react-text-transition';
function Hero(props) {

  const modal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "70%",
    bgcolor: "background.paper",
    boxShadow: 24,
    // p: 4,
    borderRadius: 3,
    background: "transparent"
  };
  const navigate = useNavigate()
  const [playVideo, setPlayVideo] = useState(false);
  const [playBtnHover, setPlayBtnHover] = useState(false);
  const [showParticles, setShowParticles] = useState(true);
  const [scrolly, setscrolly] = useState(0);
  const TEXTS = ['Humans', 'Machines', 'Applications', 'Cloud Infrastructure']
  const toggleVideo = () => {
    setPlayVideo(!playVideo)
  }

  const particlesInit = useCallback(async engine => {
    // console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    //await loadFull(engine);
    // await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async container => {
    // console.log(container);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      // console.log(window.scrollY)
      setscrolly(window.scrollY);
      if (window.scrollY > 100) {
        setShowParticles(false);
      } else {
        setShowParticles(true);
      }
    }
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [])
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((index) => index + 1),
      2000,
    );
    return () => clearTimeout(intervalId);
  }, []);
  return (
    <div className="main-hero-full">
    <div className="hero-full">
      <Container sx={{flex: 1, paddingTop: {sm: '80px', xs: "56px"}}}>
        <Box
          minHeight="max-content"
          sx={{display: "flex",paddingTop: {xs: "48px", sm: '100px'}, paddingBottom: "100px", columnGap: "0px", flexWrap: "wrap", alignItems: "center", justifyContent: "center", flexDirection: {xs: "column", md: "row", lg: "row"}}}
        >

          <Grid container sx={{flex: 1}}>

            <Box sx={{display: "flex", width: "100%", paddingTop: {lg: "0px", md: "0px", xs: "10px"}, flexDirection: "column", alignItems: "center", justifyContent: {xs: "center", xl: "center"}}}>
              <Stack style={{maxWidth: "fit-content", minWidth: "650px"}} justifyContent={"left"} spacing={"24px"}>
                <Typography
                  variant="h1"
                  sx={{
                    textAlign: { xs: "center", sm: "center", md: "left", lg: "left" },
                    width: {xs: "50%", lg: "100%", md: "100%"},
                    marginLeft: "auto",
                    marginRight: "auto",
                    font: {
                      lg: "normal normal 600 48px/120% Poppins",
                      md: "normal normal 600 48px/120% Poppins",
                      sm: "normal normal 600 48px/120% Poppins",
                      xs: "normal normal 600 32px/120% Poppins",
                    },
                    color: "#FFFFFF",
                  }}
                >
                One SSE Platform. <br />Secure Access Everywhere.
                </Typography>
                <Typography
                  className="desktop-view"
                  variant="h4"
                  sx={{
                    // fontSize:{xs:"18px",sm:"20px",md:"22px",lg:"30px"},
                    font: {
                      lg: "normal normal normal 20px/120% Poppins",
                      md: "normal normal normal 20px/120% Poppins",
                      sm: "normal normal normal 20px/120% Poppins",
                      xs: "normal normal normal 14px/120% Poppins",
                    },
                    width:{lg: '85%', md: "85%", sm: "100%", xs: '100%'},
                    alignContent: "center",
                    paddingLeft: {xs: "200px", lg: 0, sm: "100px"},
                    paddingRight: {lg: '130px' ,xs: '200px', sm: "100px"},
                    textAlign: { xs: "center", md: "left", lg: "left", sm: 'center' },
                    color: "#FFFFFF",
                  }}
                >
                    Secure AI agents, applications, data & cloud
                    with identity-centric zero trust principles.
                </Typography>
              </Stack>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: { xs: "center", lg: "left" },
                }}
              >
                <Stack
                  direction={{ lg: "row", md: "column" }}
                  alignItems="baseline"
                  justifyContent={{md: "center", xs: "left"}}
                  gap={{ lg: "16px", md: "0px", sm: "0px", xs: "0px" }}
                >
                  <Box sx={{
                    display: "flex",
                    flexDirection: {
                      sm: "row",
                      xs: "column"
                    }
                  }}
                  >
                      <Button
                        key={"get"}
                        onClick={() => {navigate('/contact')}}
                        sx={{
                          height: {
                            lg: "48px",
                            md: "48px",
                            sm: "48px",
                            xs: "48px",
                          },
                          width: 'fit-content',
                          // use this margin value when use watch now button
                          // m: {lg:"48px 1px 0px 0px",md:"48px 1px 0px 0px",sm:"48px 1px 0px 0px",xs:"16px 1px 0px 0px" },
                          m: "32px 1px 0px 0px",
                          marginLeft: { lg: "0px", sm: "0px" },
                          color: "#003FB9",
                          borderRadius: "4px",
                          opacity: 0.9,
                          backgroundColor: "#FFFFFF",
                          display: "block",
                          font: {
                            lg: "normal normal 600 20px/120% Poppins",
                            md: "normal normal 600 20px/120% Poppins",
                            sm: "normal normal 600 20px/120% Poppins",
                            xs: "normal normal 600 16px/120% Poppins",
                          },
                          letterSpacing: 0,
                          width: '235px',
                          textTransform: "none",
                          boxShadow: "0px 3px 6px #0B35583D",
                          ":hover": {
                            background:"linear-gradient(90deg, #003FB9 0%, #6943FF 100%)",
                            borderRadius: "4px",
                            border: "2px solid #CEDCFF",
                            color: "#FFFFFF",
                          },
                        }}
                      >
                       Start free trial
                      </Button>
                  </Box>
                </Stack>
              </Box>
            </Box>
            
          </Grid>
          <Box sx={{maxWidth: "608px", flex: 1, minWidth: {lg: "408px", md: "408px", xs: "200px"}, marginTop: {xs:'64px',lg:0, md: 0}}}>
          <Box component={'img'} src={heroImg} sx={{width: {lg: '115%', md: "115%", xs: "100%"}, marginTop: "1rem"}} alt="hero" />
      </Box>
        </Box>
        
      </Container>
    </div>
    </div>
  );
}

export default Hero;
